var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Preloader',{attrs:{"title":"Otimizando","subtitle":"Estamos otimizando a interface do NewsHub para você, aguarde alguns instantes :)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }